import React from 'react'
import hash from '@emotion/hash'

import { Box, BoxProps } from '../Box/Box'

type PageSearchProps = {
  items: BoxProps[]
}

export const PageSearch = ({ items }: PageSearchProps) => (
  <div className="column__main">
    <div className="column__four column--merge-a">
      {items.map((item) => (
        <div className="column ta--2" key={hash(Object.values(item).join('#'))}>
          <Box {...item} />
        </div>
      ))}
    </div>
  </div>
)

export default PageSearch
